import { createApp } from 'vue'
import { i18n } from "@/language";
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import App from '../App.vue'
import router from '../router'
import store from "@/store";
import '@/assets/scss/main.scss'
const app = createApp(App)
app.config.globalProperties.$filters = {
    breakLine(text) {
        if (!text) return '';
        return text.replace('//', '\n').replace(/\s+/g, ' ');
    }
}
app.use(VueViewer)
app.use(router)
app.use(store)
app.use(i18n)
app.mount('#app')
